<template>
  <div class="img-content-wrap">
      <el-image
      v-for="(items, idx) in params.list"
      :key="idx"
      :src="items.image" @click="itemClick(items)"></el-image>
  </div>
</template>

<script>
import {linkCommon } from '@/utils/index.js'
export default {    
    props: {
        params: {
            type: [Object, Array]
        }
    },
    methods: {
        itemClick(v) {
            linkCommon(v, this)
        },
    }
}
</script>

<style lang="scss" scoped>
.img-content-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>